import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISFMTicketingMgmt',
  mixins: [userItemsPerListMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      canReadUsers: false,
      authorNames: {},
      fab: false,
      search: null,
      dialog: false,
      tableLoading: false,
      editedIndex: -1,
      editedItem: {},
      editedItemHasCloseDate: false,
      expanded: [],
      selected: [],
      tableOptions: _objectSpread({}, defaultTableOptions),
      items: [],
      state: [{
        text: this.$i18n_t('Common.toDo'),
        value: 0
      }, {
        text: this.$i18n_t('Common.inProgress'),
        value: 1
      }, {
        text: this.$i18n_t('Common.done'),
        value: 2
      }],
      newComment: {
        date: new Date(),
        type: null,
        comment: null
      },
      fileURL: null,
      dateFromMenu: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), mapGetters({
    sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
    userObject: 'authentication/user'
  })), {}, {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? this.$i18n_t('Common.newRecord') : this.$i18n_t('Common.editRecord');
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: '',
          value: '',
          width: 30
        }, {
          sortable: true,
          text: this.$i18n_t('Common.tbl_subject'),
          class: 'tableHeader',
          value: 'subject',
          width: 150
        }, {
          sortable: true,
          text: this.$i18n_t('Common.state'),
          value: 'statusUi.text',
          width: 100
        }, {
          sortable: true,
          text: this.$i18n_t('Common.type'),
          value: 'type.name',
          width: 100
        }, {
          sortable: true,
          text: this.$i18n_t('Common.dTwin'),
          value: 'properties.dTwin.title',
          width: 160
        }, {
          sortable: true,
          text: this.$i18n_t('Common.comment'),
          value: 'lastComment'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.createdDate'),
          value: 'createdAt',
          width: 100
        }, {
          sortable: false,
          text: '',
          value: '',
          width: 50
        }, {
          sortable: false,
          text: '',
          width: 50
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  mounted: function mounted() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.$store.state.app.loading = false;
    this.fetchTickets();
    this.canReadUsers = this.permissions['UserManagement.read'];
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    shouldExpand: function shouldExpand(item) {
      if (this.expanded.length === 0 || this.expanded[0].id !== item.id) {
        var expand = item.properties && item.properties.fileId || this.canReadUsers || item.comments.length > 0;

        if (expand) {
          // details for this ticket will be expanded, so fetch the author-name
          this.fetchAuthorName(item);
        }

        return expand;
      }

      return false;
    },
    editTicket: function editTicket(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItemHasCloseDate = item.closedDate;

      if (this.editedItemHasCloseDate) {
        this.editedItem.closedDate = new Date(this.editedItem.closedDate);
      }

      this.editedItem.fileURL = item.properties && item.properties.fileId ? this.getImageURL(item.properties.fileId) : null;
      this.editedItem.imageRotate = item.properties && item.properties.imageRotate ? item.properties.imageRotate : 0;
      this.dialog = true;
    },
    fetchTickets: function fetchTickets() {
      var _this = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      ApiService.isFmTicketsFetch(this).then(function (data) {
        _this.items = data.map(function (row) {
          row.statusUi = _this.state.find(function (ele) {
            return ele.value === row.status;
          });
          row.lastComment = row.comments && row.comments.length ? row.comments[row.comments.length - 1].comment : null;
          return row;
        });

        if (!data.length) {
          _this.$snack(_this.$i18n_t('IS.FM.Ticket.noTickets'), 'success');
        }
      }).catch(function (error) {
        if (error.response && _this.$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('IS.FM.Ticket.errorFindingTicket'), 'error');
        }
      }).finally(function () {
        _this.$store.state.app.loading = false;
        _this.tableLoading = false;
      });
    },
    fetchAuthorName: function fetchAuthorName(ticket) {
      var _this2 = this;

      if (this.canReadUsers) {
        if (this.authorNames[ticket.authorId]) {
          return;
        }

        ApiService.getUser(this, ticket.authorId).then(function (data) {
          _this2.authorNames[ticket.authorId] = "".concat(data.firstName, " ").concat(data.lastName);
          _this2.authorNames = cloneDeep(_this2.authorNames);
        }).catch(function () {
          _this2.authorNames[ticket.authorId] = _this2.$i18n_t('IS.FM.Ticket.noUserReadPermission');
          _this2.authorNames = cloneDeep(_this2.authorNames);
        });
      }
    },
    editAuthor: function editAuthor(authorId) {
      this.$router.push("/account-mgmt/user/".concat(this.sessionPrimaryTenantIds[0], "/").concat(authorId));
    },
    confirmDeleteTicket: function confirmDeleteTicket(item) {
      confirm(this.$i18n_t('Common.areYouSure')) && this.deleteTicket(item);
    },
    close: function close() {
      var _this3 = this;

      this.dialog = false;
      setTimeout(function () {
        _this3.clearFields();

        _this3.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        this.updateTicket();
      }
    },
    updateTicket: function updateTicket() {
      var _this4 = this;

      this.tableLoading = true;

      if (this.editedItem.type && this.editedItem.type.name) {
        this.newComment.type = this.editedItem.type.name;
      }

      this.newComment.date = new Date();
      this.editedItem.comments.push(this.newComment);
      ApiService.isFmTicketUpdate(this.editedItem).then(function () {
        _this4.clearFields();

        _this4.close();

        _this4.fetchTickets();

        _this4.$snack(_this4.$i18n_t('IS.FM.Ticket.updateTicketObj'), 'success');

        _this4.$store.state.app.refreshToolbar += 1;
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('IS.FM.Ticket.updateTicketObjFaild'), 'error');
        }
      });
    },
    deleteTicket: function deleteTicket(item) {
      var _this5 = this;

      this.tableLoading = true;
      ApiService.isFmTicketDelete(item.id).then(function () {
        _this5.$snack(_this5.$i18n_t('IS.FM.Ticket.deleteTicketObj'), 'success');

        _this5.$store.state.app.refreshToolbar += 1;
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('IS.FM.Ticket.deleteTicketObjFaild'), 'error');
        }
      }).finally(function () {
        _this5.fetchTickets();
      });
    },
    getStatusText: function getStatusText(id) {
      var state = this.state.find(function (ele) {
        return ele.value === id;
      });
      return state.text;
    },
    date: function date(_date) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_date) {
        var locale = window.navigator.userLanguage || window.navigator.language;
        moment.locale(locale);
        return time ? moment(_date).format('L LT') // produces a localised version of 'DD/MM/YYYY hh:ss:ii A'
        : moment(_date).format('L'); // produces a localised version of 'DD/MM/YYYY'
      }
    },
    closedDatePicked: function closedDatePicked(dateObject) {
      this.editedItem.closedDate = new Date(dateObject.from * 1000);
    },
    getImageURL: function getImageURL(fileId) {
      if (fileId) {
        return "".concat(this.$store.state.app.baseURL, "/upload/").concat(fileId);
      }
    },
    clearFields: function clearFields() {
      this.editedItem = {};
      this.newComment.comment = null;
    },
    imageRotate: function imageRotate(turn) {
      if (turn) {
        return {
          transform: "rotate(".concat(turn, "turn)")
        };
      }
    }
  })
};